import $ from "jquery";

export default class Search {
    constructor() {
        this.toggle = $('[data-toggle-search]');
        if(this.toggle) {
            this.toggle.on('click', () => this.toggleSearch(true));
        }
        this.siteSearchInput = document.querySelector('.site-search .input');
        this.siteSearch = document.querySelector('.site-search');
        if(this.siteSearch) {
        this.siteSearch.addEventListener('click', e => {
            e.target.classList.contains('active') && this.toggleSearch(false);
        });
            $('.site-search .close').on('click', () => this.toggleSearch(false));
        }
    }

    toggleSearch(v) {
        this.siteSearch.classList.toggle('active', v);
        !!v && this.siteSearchInput.focus();
    }
}